import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { getQuestionDifficulty, QuestionStoreModel } from '@examdojo/question';
import { DifficultyComponent } from '@examdojo/ui/difficulty';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatTooltip } from '@angular/material/tooltip';
import { CalculatorIndicatorComponent } from '../calculator-indicator/calculator-indicator.component';

@Component({
  selector: 'dojo-question-header-readonly',
  standalone: true,
  templateUrl: './question-header-readonly.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CalculatorIndicatorComponent, DifficultyComponent, IconComponent, MatTooltip, TranslocoPipe],
})
export class QuestionHeaderReadonlyComponent {
  readonly question = input.required<QuestionStoreModel>();

  readonly totalMarks = computed(() => {
    return this.question().max_points ?? 0;
  });

  readonly difficulty = computed(() => {
    return getQuestionDifficulty(this.question());
  });
}
